import {ReferralRepository} from '@raf/core/domain/ReferralRepository';

type GetReferralType = (repository: ReferralRepository) => ReferralRepository['getReferral'];

const GetReferral: GetReferralType = repository => () => {
  return repository.getReferral();
};

export {GetReferral};
